(() => {
  // REZEPTKARTEN
  const REGULAR_RECIPE_VARIANTS = new Set([
    53439287591178, // Sommerrezepte
    53424134390026, // Alltagsküche
    53436792209674, // Familienküche
    53436809969930  // Winterrezepte
  ]);

  const ADDON_VARIANTS = new Set([
    53437076635914, // Sattmacher
    53437073195274  // Julias Lieblinge
  ]);

  const REQUIRED_RECIPE_QUANTITY = 4;


  // AIRFRYER KOCHBUCH + SILIKONFORMEN
  const AIRFRYER_BOOK_VARIANT = 53908552253706;

  const AIRFRYER_ADDON_VARIANTS = new Set([
    53909537915146, // Grau
    53909537947914, // Türkis
    53909537980682  // Rosa
  ]);


  let checkInProgress = false;
  let debounceTimer = null;


  async function getCart() {
    const response = await fetch(
      `${window.Shopify.routes.root}cart.js`,
      {
        headers: {
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error(
        `Warenkorb konnte nicht geladen werden: ${response.status}`
      );
    }

    return response.json();
  }


  async function removeAddonByLine(lineNumber) {
    const response = await fetch(
      `${window.Shopify.routes.root}cart/change.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          line: lineNumber,
          quantity: 0
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        `Add-on konnte nicht entfernt werden: ${response.status}`
      );
    }

    return response.json();
  }


  async function enforceAddonRules() {
    if (checkInProgress) return;

    checkInProgress = true;

    try {
      const cart = await getCart();


      // -------------------------
      // REGEL 1: REZEPTKARTEN
      // -------------------------

      const regularRecipeQuantity = cart.items.reduce(
        (total, item) => {
          return REGULAR_RECIPE_VARIANTS.has(
            Number(item.variant_id)
          )
            ? total + item.quantity
            : total;
        },
        0
      );


      // -------------------------
      // REGEL 2: AIRFRYER
      // -------------------------

      const hasAirfryerBook = cart.items.some(
        item =>
          Number(item.variant_id) === AIRFRYER_BOOK_VARIANT &&
          item.quantity > 0
      );


      // -------------------------
      // ZU ENTFERNENDE ADD-ONS
      // -------------------------

      const addonLinesToRemove = cart.items
        .map((item, index) => ({
          item,
          line: index + 1
        }))
        .filter(({ item }) => {
          const variantId = Number(item.variant_id);

          const invalidRecipeAddon =
            ADDON_VARIANTS.has(variantId) &&
            regularRecipeQuantity < REQUIRED_RECIPE_QUANTITY;

          const invalidAirfryerAddon =
            AIRFRYER_ADDON_VARIANTS.has(variantId) &&
            !hasAirfryerBook;

          return invalidRecipeAddon || invalidAirfryerAddon;
        });


      if (addonLinesToRemove.length > 0) {

        // Von hinten entfernen, damit sich die
        // Warenkorb-Zeilennummern nicht verschieben.
        addonLinesToRemove.sort(
          (a, b) => b.line - a.line
        );

        for (const addon of addonLinesToRemove) {
          await removeAddonByLine(addon.line);
        }

        window.location.reload();
      }

    } catch (error) {
      console.error(
        'MPB Add-on-Regeln:',
        error
      );

    } finally {
      checkInProgress = false;
    }
  }


  function scheduleCheck(delay = 2500) {
    window.clearTimeout(debounceTimer);

    debounceTimer = window.setTimeout(() => {
      enforceAddonRules();
    }, delay);
  }


  document.addEventListener('DOMContentLoaded', () => {
    scheduleCheck(3000);
  });


  document.addEventListener('click', event => {
    const removeOrQuantityControl = event.target.closest(
      'a[href*="/cart/change"], a[href*="/cart/clear"], quantity-input, button[name="minus"], button[name="plus"]'
    );

    if (removeOrQuantityControl) {
      scheduleCheck(2500);
    }
  });


  document.addEventListener('change', event => {
    if (
      event.target.matches(
        'input[name="updates[]"], input[name^="updates"], input[type="number"]'
      )
    ) {
      scheduleCheck(2500);
    }
  });


  document.addEventListener('cart:updated', () => {
    scheduleCheck(2500);
  });


  document.addEventListener('cart:update', () => {
    scheduleCheck(2500);
  });

})();